import * as actionTypes from '../config/actionTypes';

const initialState = {
  loading: false,
  next: null,
  feed: [],
  count: 0,
  error: null,
  profile: null,
};


const dashboardLoadingReducer = (state) => {
  return {
    ...state,
    loading: !state.loading,
  };
};


const displayFeedReducer = (state, data) => {
  return {
    ...state,
    feed: [
      ...state.feed,
      ...data.results,
    ],
    count: data.count,
    next: data.next,
  };
};


const dashboardErrorReducer = (state, error) => {
  return {
    ...state,
    error: error,  // eslint-disable-line
  };
};


const feedUnmountReducer = (state) => {
  return {
    ...state,
    ...initialState,
  };
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_DASHBOARD_LOADING: return dashboardLoadingReducer(state);
    case actionTypes.DISPLAY_FEED: return displayFeedReducer(state, action.payload);
    case actionTypes.DASHBOARD_ERROR: return dashboardErrorReducer(state, action.payload);
    case actionTypes.FEED_UNMOUNT: return feedUnmountReducer(state);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/dashboard/reducers.js